import { queryOptions, useQuery } from '@tanstack/react-query';

import { getPromoHighlights } from '../queries/promos';
import { useAuthStore, useShipToStore } from '../stores';

export const PROMO_HIGHTLIGHTS_QUERY_KEY = 'PromoHiglights';

export function getPromoHighlightsOptions(
  access_token: string,
  warehouse: string
) {
  return queryOptions({
    queryKey: [PROMO_HIGHTLIGHTS_QUERY_KEY],
    queryFn: () => getPromoHighlights(access_token, warehouse),
    retry: false,
    enabled: !!warehouse,
    refetchOnWindowFocus: (q) => q.state.data !== undefined,
  });
}

export const useGetPromoHighlights = () => {
  const session = useAuthStore();
  const { selectedShipToId } = useShipToStore();
  return useQuery(
    getPromoHighlightsOptions(session.access_token, selectedShipToId)
  );
};
